<template>
  <div class="order-claim">
    <div ref="order" class="label-step" v-if="orderType == 1">
      <div ref="birdman" class="bird">
        <div  ref="message" class="message-box left">
          <div class="top"></div>
          <div class="wrap">
            <h3>Brawo<br />Mistrzu!</h3>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div class="order">
        <div ref="label" class="order-label"></div>
        <div ref="line" class="line"></div>
      </div>
      <div class="bar">
        <div class="bar-wrap">
          <div ref="statbar" class="status-bar"></div>
        </div>
      </div>
    </div>
    <div ref="order2" class="label-step game_two" v-if="orderType == 2">
      <div ref="birdman" class="bird">
        <div  ref="message" class="message-box left">
          <div class="top"></div>
          <div class="wrap">
            <h3>Dobra<br />Robota!</h3>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div class="order game_two">
        <div ref="label" class="order-label game_two"></div>
        <div ref="line" class="line"></div>
      </div>
      <div class="bar game_two">
        <div class="bar-wrap">
          <div ref="statbar2" class="status-bar"></div>
        </div>
      </div>
    </div>
    <div ref="order3" class="label-step game_tree" v-if="orderType == 3">
      <div ref="birdman" class="bird">
        <div  ref="message" class="message-box left">
          <div class="top"></div>
          <div class="wrap">
            <h3>Tak<br />Trzymaj!</h3>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
      <div class="order game_two">
        <div ref="label" class="order-label game_tree"></div>
        <div ref="line" class="line"></div>
      </div>
      <div class="bar game_tee">
        <div class="bar-wrap end">
          <div ref="statbar3" class="status-bar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TimelineLite} from "gsap";
import {mapGetters} from "vuex";
export default {
name: "OrganismGameOrder",
  props:{
    orderType:{
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters(['setupGame']),
  },

  mounted() {
    const timeline = new TimelineLite()
    const { order, order3, statbar2, statbar3, order2, line, statbar, label, birdman, message } = this.$refs
    if (window.innerWidth > 800){
      timeline
          .set(line,  {height:0})
          .set(message,  {opacity:0})
          .set(label, {scale:0})
          .set(statbar,  {width:0})

          .to(order, 0.2,  { x: -900})
          .to(order2, 0.2,  { x: -1200})
          .to(order3, 0.2,  { x: 900})

          .to(line, 0.2, {height:130})

          .to(statbar, 0.2,  {width:"10%"})
          .to(statbar2, 0.2,  {width:"58%"})
          .to(statbar3, 0.2,  {width:"98%"})

          .to(label,  0.2, {scale:1})
          .to(birdman,  {x: -920})
          .to(message,  {opacity:  1})
    }

        this.$confetti.start({
          particles: [
              {
                type: 'rect',
              }   ],
          defaultColors: [
              '#00eeac',
              '#fd032e',
              '#fdab00',
              '#03b9cd',
              '#00ee00',
              '#5900cd',
              '#bcee00',
              '#fd7f00',
              '#fd044c',
              '#fde400',
              '#fde400',
              '#fde400',
          ],
        });

    setTimeout(function(scope) {
      scope.$confetti.stop();
    }, 2000, this);



    },
}
</script>
